import * as Sentry from "@sentry/react";
import type { ErrorInfo } from "react";
import ErrorPage from "@/app/error";

// A default error component gives every route match its own boundary, so a
// failing page is replaced by the recovery screen inside its parent layouts
// rather than the whole app falling through to TanStack's bare fallback.
export const routeErrorOptions = {
  defaultErrorComponent: ErrorPage,
  defaultOnCatch: (error: Error, errorInfo: ErrorInfo) => {
    Sentry.captureReactException(error, errorInfo);
  },
};
